/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import instances from './map';

export const adicionarGto = async ({ codigoBeneficiario, codigoPrestador, dadosGuia }) =>
  instances
    // Deixar apenas uma das três linhas abaixo descomentadas
    // .mobileengine_local({
    // .mobileengine_fis({
    .prestador_odonto({
      method: 'POST',
      url: `/prestadores/${codigoPrestador}/beneficiarios/${codigoBeneficiario}/guias-tratamento`,
      data: dadosGuia
    })
    .then(response => {
      if (response.status === 201) {
        return response.data;
      }
      if (response.status === 400) {
        if (response.data.message !== null && response.data.message.includes("atendimento ao produto")) {
          return Promise.reject(new Error("Prezado (a) Prestador (a), você não está contratado para o atendimento ao produto deste beneficiário."));
        }

        if (response.data.message !== null && response.data.message.includes("solicitação de manutenção")) {
          return Promise.reject(new Error("Prezado (a) Prestador (a), para a próxima solicitação de manutenção ortodôntica é necessário utilizar o Sad.Net."));
        }
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      if (response.status === 500) {
        return Promise.reject(
          new Error('Não foi possível criar a GTO. Por favor entrar em contato com a SulAmérica')
        );
      }
      return Promise.reject(new Error('Não foi possível criar a GTO. Tente novamente'));
    });

export const buscarGtos = async ({ codigoPrestador, codigoBeneficiario, dt_inicio, dt_fim }) =>
  instances
    .prestador_odonto({
      method: 'GET',
      url: `/prestadores/${codigoPrestador}/beneficiarios/${codigoBeneficiario}/guias-tratamento`,
      params: {
        dt_inicio,
        dt_fim
      }
    })
    .then(response => {
      if (response.status === 200) return response.data;
      if (response.status === 404) return null;
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });

export const buscarGtoProcedimentosDetalhes = async ({ codigoPrestador, gtoId }) => {
  return instances
    .prestador_odonto({
      method: 'GET',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}`,
    })
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
    })
    .catch(err => {
      console.error('Erro ao buscar informações GTO', err.message);
      return Promise.reject(
        new Error('Não foi possível buscar informações da GTO no momento, tente novamente mais tarde.')
      );
    });
};


export const buscarPacientes = async ({ codigoPrestador, filtro, status_gto }) =>
  instances
    .prestador_odonto({
      method: 'GET',
      url: `/prestadores/${codigoPrestador}/beneficiarios`,
      params: {
        _sort: 'NOME',
        _limit: 50,
        status_gto,
        filtro
      }
    })
    .then(response => {
      if (response.status === 206) {
        return response.data._embedded._result;
      }
      if (response.status === 404) {
        return [];
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });

export const adicionarPaciente = async patient => {
  const { codigoPrestador, nome, numero_carteirinha, telefone_beneficiario } = patient;

  return instances
    .prestador_odonto({
      method: 'POST',
      url: `/prestadores/${codigoPrestador}/beneficiarios`,
      data: {
        nome,
        numero_carteirinha,
        telefone_beneficiario
      }
    })
    .then(response => {
      if (response.status === 201) {
        return response;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      if (response.status === 409) {
        return Promise.reject(new Error('Paciente já cadastrado'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });
};

export const buscarProcedimentosExclusivos = async () =>
  instances
    .prestador_odonto({
      method: 'GET',
      url: '/procedimentos-exclusivos'
    })
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return null;
    });

export const adicionarInfoProcedimento = async ({
  codigoPrestador,
  gtoId,
  idProcedimento,
  dataRealizacao
}) =>
  instances
    .prestador_odonto({
      method: 'PATCH',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/procedimentos/${idProcedimento}`,
      data: {
        data_realizacao: dataRealizacao
      }
    })
    .then(response => {
      if (response.status === 204) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });

export const adicionarImagemProcedimento = async ({
  codigoPrestador,
  gtoId,
  idProcedimento,
  categoriaImagem,
  nomeArquivo
}) =>
  instances
    .prestador_odonto({
      method: 'POST',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/procedimentos/${idProcedimento}/imagens`,
      data: {
        nome_arquivo: nomeArquivo,
        categoria_imagem: categoriaImagem
      }
    })
    .then(response => {
      if (response.status === 201) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });

export const adicionarImagemGto = async ({ codigoPrestador, gtoId, nomeArquivo }) =>
  instances
    .prestador_odonto({
      method: 'POST',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/imagens`,
      data: {
        nome_arquivo: nomeArquivo
      }
    })
    .then(response => {
      if (response.status === 201) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Serviço indisponível'));
    });

export const buscarInfoProcedimentos = async ({ codigoPrestador, gtoId }) =>
  instances
    .prestador_odonto({
      method: 'GET',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/imagens`
    })
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
    });

export const faturarGto = async ({
  codigoPrestador,
  codigoBeneficiario,
  gtoId,
  observacoes,
  procedimentos
}) =>
  instances
    .prestador_odonto({
      method: 'POST',
      url: `/prestadores/${codigoPrestador}/beneficiarios/${codigoBeneficiario}/guias-tratamento/${gtoId}/faturamentos`,
      data: {
        observacoes,
        procedimentos
      }
    })
    .then(response => {
      if (response.status === 201) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      if (response.status === 504) {
        return Promise.reject(new Error('Erro ao faturar GTO. Tente novamente'));
      }
      return Promise.reject(
        new Error('Erro ao faturar GTO. Por favor entrar em contato com a Sulamérica')
      );
    });

export const excluirDataRealizacao = async ({ codigoPrestador, gtoId, idProcedimento }) =>
  instances
    .prestador_odonto({
      method: 'DELETE',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/procedimentos/${idProcedimento}/imagens`
    })
    .then(response => {
      if (response.status === 204) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Erro ao excluir dados do procedimento'));
    });

export const excluirGtoAssinada = async ({ codigoPrestador, gtoId }) =>
  instances
    .prestador_odonto({
      method: 'DELETE',
      url: `/prestadores/${codigoPrestador}/guias-tratamento/${gtoId}/imagens`
    })
    .then(response => {
      if (response.status === 204) {
        return response.data;
      }
      if (response.status === 401) {
        return Promise.reject(new Error('Sessão expirada. Faça o login novamente'));
      }
      return Promise.reject(new Error('Erro ao excluir dados do procedimento'));
    });

export default {
  buscarGtos,
  buscarPacientes,
  adicionarPaciente,
  adicionarGto,
  buscarProcedimentosExclusivos,
  adicionarInfoProcedimento,
  adicionarImagemProcedimento,
  buscarInfoProcedimentos,
  faturarGto,
  adicionarImagemGto,
  excluirDataRealizacao,
  excluirGtoAssinada,
  buscarGtoProcedimentosDetalhes
};
